<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">财务</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">财务充值</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">充值中心</div>
      </div>
      <div class="panel-body">
        <el-tabs v-model="activeName" type="border-card">
          <el-tab-pane label="在线充值" name="first">
            <div class="alert-warn">
              <p>1、充值最小金额0.3元</p>
              <p>2、支付过程中浏览器会有几次跳转，支付完成之前请勿关闭浏览器，否则可能造成支付失败</p>
              <p>3、如充值后款项没有到账，请联系 <a href="/about/#contactUs" class="z-color-a z-curPonit a-underline-link" target="_blank">在线客服</a> 帮助处理，或 <router-link to="fuwu" class="z-color-a a-underline-link" target="_blank">提交工单</router-link></p>
            </div>
            <el-form :model="payForm" id="pay" label-width="120px" ref="payForm" :rules="rules" class="xufei-form" action="https://www.sanfengyun.com/pay.html" method="get" target="_blank">
              <el-form-item label="账户余额：">
                <span class="z-font-size-16 z-color-66-orange z-font-weight-700">{{payForm.balance}}元</span>
              </el-form-item>
              <el-form-item label="充值金额：" prop="recharge">
                <el-input name="money" v-model="payForm.recharge" style="width: 150px"></el-input>
                <span class="z-font-size-12"> 元</span>
              </el-form-item>
              <el-form-item label="销售编号：">
                <el-input name="saleuser" v-model="payForm.number" style="width: 150px"></el-input>
                <span class="z-color-red">（可为空）</span>
              </el-form-item>
              <el-form-item label="支付方式：">
                <div class="payment-tier clearfix">
                  <!-- 支付宝 -->
                  <div class="payment-item">
                    <input type="radio" id="alipay" v-model="payType" value="alipay">
                    <label for="alipay" :class="{'pay-select': payType === 'alipay'}">
                      <span class="payment-choose payment-alipay"></span>
                      <i></i>
                    </label>
                  </div>
                  <!-- 微信支付 -->
                  <div class="payment-item">
                    <input type="radio" id="weixin" v-model="payType" value="weixin">
                    <label for="weixin" :class="{'pay-select': payType === 'weixin'}">
                      <span class="payment-choose payment-weixin"></span>
                      <i></i>
                    </label>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" style="width: 120px" @click="submitForm('payForm')">充值</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="线下汇款" name="second">
            <div class="alert-warn">
              <p>温馨提示：建议您首先采用微信、支付宝、银行卡<a href="javascript:;" class="z-color-a z-curPonit a-underline-link" @click="activeName = 'first'">在线充值</a>，金额可实时到账；线下汇款受银行系统影响，到账时间可能会存在延迟。</p>
            </div>
            <div class="detail-title">
              在线支付    在线支付实时到帐，无须等待我们确认，建议使用！
            </div>
            <div class="detail-body">
              <div class="company">
                <p class="z-margin-bottom-10-precent">户　名：北京太极三丰云计算有限公司</p>
                <p class="z-margin-bottom-10-precent">开户行：北京农商银行天通苑支行</p>
                <p>帐　号：2000000083757</p>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="微信扫码支付" :lock-scroll="false" :visible.sync="dialogWeixin" width="660px" @close="closeWeixin">
      <h1 class="z-textAlign-center z-font-size-16 z-lineHeight-30">请使用微信“扫一扫”功能扫描下方二维码进行支付</h1>
      <h2 class="z-textAlign-center z-font-size-16 z-lineHeight-30">本次充值金额：<span class="z-font-weight-700 z-font-size-16" style="color: #f60;">{{payForm.recharge}}</span> 元</h2>
      <div v-loading="listLoading">
        <div style="width:240px; height:240px; background:#fff; margin:0 auto; border:1px solid #ccc;margin-top:20px;position:relative">
          <img :src="dataUrl" alt="">
        </div>
      </div>
      <div id="status" style="text-align:center;height:30px;line-height:30px;color:#999;margin-top:10px">
        {{payState}}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogWeixin = false">取消支付</el-button>
      </div>
    </el-dialog>
    <!--<div id="pay"></div>-->
  </div>
</template>
<script>
  import Xbutton from 'components/commons/Xbutton.vue'
  import userService from 'business/userService.js'
  import payService from 'business/payService.js'
  export default {
    data () {
      var checkAge = (rule, value, callback) => {
        if (value < 0.3) {
          callback(new Error('最低起充金额为0.3元'));
        } else {
          callback();
        }
      };
      return{
        dialogWeixin:false,
        listLoading:false,
        activeName:'first',
        payForm:{
          balance:'',
          recharge:'',
          number:'',
        },
        payType:'alipay',
        dataUrl:'',
        trade:'',
        payState:'',
        rules:{
          recharge: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { validator: checkAge, trigger: 'blur' },
            // { pattern: /^[1-9]\d{0,5}(\.0{1,2})?$/, message: '金额为数字且为整数', trigger: 'blur' },
          ],
        }
      }
    },
    components:{
      Xbutton
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.getmoney()
    },
    methods:{
      async submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit()
          } else {
            return false;
          }
        });
      },
      async getmoney() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=userinfo')
        if(vueData.response == 200 ) {
          this.payForm.balance = vueData.msg.money
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async submit() {
        if(this.payType === 'weixin'){
          this.dialogWeixin = true
          this.listLoading = true
          let data = 'cmd=pay_wx'+
            '&pay_money='+ this.payForm.recharge +
            '&pay_saleuser='+ this.payForm.number
          let {vueData, state} = await payService.transformToVue('payInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dataUrl = vueData.msg
            this.trade = vueData.out_trade_no
            this.listLoading = false
            this.timer = setInterval(() => {
              this.checkPay()
            },1000)
          }else {
            this.$dialog({
              type:'error',
              info: vueData.msg,
              click () {}
            })
          }
        }
        if(this.payType === 'alipay'){
          document.getElementById('pay').submit();
          //这种方式浏览器禁止弹窗就打不开 所以get一个新窗口 再请求
          /*let data = 'cmd=pay_zfb'+
            '&pay_money='+ this.payForm.recharge +
            '&pay_saleuser='+ this.payForm.number
          let {vueData, state} = await payService.transformToVue('payInfo','POST',data)
          if(vueData.response == 200 ) {
            document.getElementById('pay').innerHTML = vueData.msg
            document.forms['alipaysubmit'].submit();
          }else {
            this.$toast(vueData.msg,'fail')
          }*/
        }
      },
      async checkPay() {
        let data = 'cmd=pay_wx_check'+
          '&out_trade_no='+ this.trade
        let {vueData, state} = await payService.transformToVue('payInfo','POST',data)
        if(vueData.response == 200 ) {
          this.payState = vueData.msg
          if(vueData.msg === '支付成功'){
            clearInterval(this.timer)
            this.$router.push('/caiwu2')
          }
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      closeWeixin() {
        this.dataUrl = ''
        clearInterval(this.timer)
      }
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .alert-warn {
    margin-bottom: 20px;
  }
  .payment-tier {
    margin-bottom: 15px;
  }
  .payment-item {
    float: left;
    width: 150px;
    margin-bottom: 6px;
    line-height: 1;
  }
  .payment-item label {
    position: relative;
  }
  .payment-item input {
    height: 40px;
    margin: 0;
  }
  .payment-item input[type=radio] {
    outline: none;
  }
  .payment-item label {
    margin: 0;
    display: inline-block;
    max-width: 100%;
  }
  .payment-choose:hover {
    border-color: #00aaff;
  }
  .payment-choose {
    float: left;
    display: inline-block;
    width: 132px;
    height: 40px;
    margin-left: -16px;
    border: 1px solid #eee;
    cursor: pointer;
  }
  .payment-alipay {
    background: url(../../assets/imgs/pay_alipay.png) no-repeat;
    background-position: center;
  }
  .payment-weixin {
    background: url(../../assets/imgs/pay_weixin.png) no-repeat;
    background-position: center;
  }
  .pay-result b {
    margin-left: 5px;
    color: #ff8800;
  }
  .pay-result b a {
    text-decoration: none;
  }
  .pay-text a {
    text-decoration: none;
  }
  input[type="radio"] {
    opacity: 0;
    filter:alpha(opacity=0);
  }
  .pay-select > span {
    border-color: #00aaff;
  }
  .pay-select i {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background: url(../../assets/imgs/pay-select-icon.png) no-repeat bottom right;
  }
  .detail-title {
    margin-top: 30px;
    background-color: #fbfbfb;
    font-size: 12px;
    line-height: 2em;
    padding: 7px 22px 5px 15px;
    border: 1px solid #e5e5e5;
  }
  .detail-body {
    padding: 20px 30px;
    border: 1px solid #ddd;
    border-top-width: 0;
  }
  .company {
    background: url(../../assets/imgs/pay2.png) no-repeat 35px 15px;
    padding: 0 0 20px 222px;
    line-height: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/caiwu/caiwu2.vue